import { FieldKey } from '../../context/field-keys.js';
import { rentConversionRules } from '../../shared/conversion.js';
/**
 * Availability min/max asking-rate yearly <-> monthly conversion, ported from
 * `business-rules/availability/rate-calc.ts` (`minAskingRate` / `maxAskingRate` via `commonRentCalc`).
 * Same `×12` / `÷12` math. The `askingRate*Validation` functions there are validations (host-side).
 */
export const AVAIL_MIN_ASKING_RATE_PAIR = {
  idPrefix: 'availability.min-asking-rate',
  monthly: FieldKey.AvailMinAskingRateMonthly,
  yearly: FieldKey.AvailMinAskingRateYearly
};
export const AVAIL_MAX_ASKING_RATE_PAIR = {
  idPrefix: 'availability.max-asking-rate',
  monthly: FieldKey.AvailMaxAskingRateMonthly,
  yearly: FieldKey.AvailMaxAskingRateYearly
};
export const availabilityRateRules = [...rentConversionRules(AVAIL_MIN_ASKING_RATE_PAIR), ...rentConversionRules(AVAIL_MAX_ASKING_RATE_PAIR)];
